import {
  Box, Button, Flex, Heading, Image
} from "@chakra-ui/react";
import React from "react";
import {useQuery} from "react-query";
import {useNavigate} from "react-router-dom";

import {getRegisterPeriod} from "../shared/Api";
import {disableBlurProtection} from "../shared/hooks/BlurProtection";
import {Paths} from "../shared/model/Constants";
import {publicKeys} from "../shared/QueryKeys";
import {enableKeyCommands, extractData} from "../shared/Utils";

const IntroAvatai = () => {
  const navigate = useNavigate();

  disableBlurProtection();
  enableKeyCommands();

  const registerQuery = useQuery(publicKeys.licenseRequest(), () =>
  { return getRegisterPeriod().then(extractData); });

  const buttonProps = {
    borderWidth:"3px",
    borderRadius:"100px",
    borderColor:'blue',
    variant:'outline',
    width:"15em",
    paddingY:"1em",
    height:"4em",
    fontSize:'xl',
    minW:"auto",
    fontWeight:"bold"
  };

  return (
    <Box maxW="container.lg" minW="100%" textAlign="center"
         bgImage="/images/roundedBg.png"
         backgroundColor="rgba(255,255,255,0.8)"
         backgroundBlendMode="lighten" bgPos="right -50% top"
         bgRepeat="no-repeat" bgSize="70% 110%"
         paddingTop="1em" paddingBottom="2em">
      <Heading width="100%">AvatAI</Heading>
      <Box maxW="container.sm" marginX="auto" paddingTop="2em">
        <Flex justify="space-evenly" align="center" paddingY="1em">
          <Image src="/images/icons/checkIcon.png" height="6em" />

          <Button onClick={()=>navigate(Paths.AVATAI_REGISTER)}
                  isLoading={(registerQuery.isLoading || registerQuery.isFetching)}
                  disabled={(registerQuery.isLoading || registerQuery.isFetching) || registerQuery.data===false}
                  _disabled={{
                    cursor: 'default',
                    opacity: '0.4',
                  }}
                  {...buttonProps}>
            Regístrate para realizar<br/>la prueba AvatAI.
          </Button>

        </Flex>
        <Flex justify="space-evenly" align="center" paddingY="1em">
          <Image src="/images/icons/sendMailIcon.png" height="6em" />
          <Button onClick={()=>navigate(Paths.AVATAI_RESEND_EMAIL)}
                  {...buttonProps}>
            Reenvía tus datos para<br/>realizar la prueba AvatAI.

          </Button>
        </Flex>
        <Flex justify="space-evenly" align="center" paddingY="1em">
          <Image src="/images/icons/pcIcon.png" height="6em" />
          <Button onClick={()=>navigate(Paths.LOGIN)}
                  {...buttonProps}>
            Realiza la prueba AvatAI.
          </Button>

        </Flex>
      </Box>
    </Box>
  );
};

export default IntroAvatai;
